import React, { useEffect, useState } from 'react';
import { ButtonUI, DialogUI, InputUI } from '../Interface';
import FormLabelUi from '../Interface/FormLabelUi';
import { Box } from '@mui/material';
import { sxConfig } from './workSheetCreator.style';

const DescriptionDialog = ({ descDialogData, handleClose, onChangeNote }) => {
  const [localValue, setLocalValue] = useState(descDialogData.note ?? '');

  useEffect(() => {
    setLocalValue(descDialogData.note ?? '');
  }, [descDialogData]);

  return (
    <DialogUI
      open={descDialogData.open}
      onClose={handleClose}
      headerContent="Megjegyzés"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': { width: '100%', maxWidth: '600px', mx: 1 },
        },
        '& .MuiDialogContent-root': {
          px: 1,
        },
      }}
    >
      <Box sx={sxConfig.descDialogContainer}>
        <InputUI
          label={<FormLabelUi text="Megjegyzés" />}
          value={localValue}
          onChange={(e) => setLocalValue(e.target.value)}
        />
        <Box sx={sxConfig.descDialogButtonContainer}>
          <ButtonUI
            text="Mentés"
            className="bg-success"
            disabled={!Boolean(localValue)}
            onClick={() => {
              onChangeNote(localValue);
              handleClose();
            }}
          />
          <ButtonUI text="Bezárás" className="bg-primary" onClick={handleClose} />
        </Box>
      </Box>
    </DialogUI>
  );
};

export default DescriptionDialog;
